<script setup>
  import { ref, computed } from "vue";
  import { storeToRefs } from "pinia";
  import { useRoute } from "vue-router";
  import { Button } from "@/components/ui/button";
  import { useSurveyLearningsStore } from "@stores/survey/surveyLearnings";

  const learningsStore = useSurveyLearningsStore();
  const { saveLearnings } = learningsStore;
  const { hasLearningsChanged } = storeToRefs(learningsStore);

  const route = useRoute();

  const isLoadingLearnings = ref(false);

  const canSave = computed(() => {
    return hasLearningsChanged?.value;
  });

  const handleSaveLearnings = async () => {
    isLoadingLearnings.value = true;
    await saveLearnings(route.params.token);
    isLoadingLearnings.value = false;
  };
</script>

<template>
  <div class="navbar__right-container__nav-buttons__btn-save">
    <Button
      size="lg"
      :loading="isLoadingLearnings"
      :disabled="isLoadingLearnings || !canSave"
      @click="handleSaveLearnings()">
      Save
    </Button>
  </div>
</template>
